"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../../common/dto/batch-result");
require("./lead-card-dto");
class ILULeadsDashboardDto {
}
exports.ILULeadsDashboardDto = ILULeadsDashboardDto;
